import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IDataUserLocalStorage,
  USER_AUTH_SLICE,
  UserAuth,
  UserAuthSlice,
} from "./userAuth.constant";

import { localStorageService } from "../../../service/localStorage.service";
import { login, refreshToken, refreshTokenInUse } from "./userAuth.thunk";

const initialState: UserAuthSlice<UserAuth> = {
  data: null,
  loading: false,
};
export const userAuthSlice = createSlice({
  name: USER_AUTH_SLICE,
  initialState,
  reducers: {
    logout: (state) => {
      return initialState; // Reset lại trạng thái khi logout
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      login.fulfilled,
      (state, action: PayloadAction<UserAuth>) => {
        const data = action.payload;
        if (data.token) {
          const dataAuthUser: IDataUserLocalStorage = {
            token: data.token,
          };
          localStorageService.setItem<IDataUserLocalStorage>(
            "auth-user",
            dataAuthUser
          );
        }
        state.data = data;
      }
    );

    builder.addCase(login.rejected, (state, action: PayloadAction<any>) => {
      state.data = null;
    });
    builder.addCase(
      refreshToken.fulfilled,
      (state, action: PayloadAction<UserAuth | null>) => {
        state.loading = false;
        const data = action.payload;
        if (data === null) return;
        if (data.token) {
          const dataAuthUser: IDataUserLocalStorage = {
            token: data.token,
          };
          localStorageService.setItem<IDataUserLocalStorage>(
            "auth-user",
            dataAuthUser
          );
        }
        state.data = data;
      }
    );
    builder.addCase(
      refreshTokenInUse.fulfilled,
      (state, action: PayloadAction<UserAuth | null>) => {
        const data = action.payload;
        if (data === null) return;
        if (data.token) {
          const dataAuthUser: IDataUserLocalStorage = {
            token: data.token,
          };
          localStorageService.setItem<IDataUserLocalStorage>(
            "auth-user",
            dataAuthUser
          );
        }
        state.data = data;
      }
    );
    builder.addCase(
      refreshTokenInUse.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
      }
    );
    builder.addCase(
      refreshTokenInUse.pending,
      (state, action: PayloadAction<any>) => {
        state.loading = true;
      }
    );
    // builder.addCase(logout.rejected, (state, action: PayloadAction<any>) => {
    //   state.data = null;
    // });
    // builder.addCase(logout.fulfilled, (state, action: PayloadAction<any>) => {
    //   state.data = null;
    // });
  },
});
export default userAuthSlice.reducer;
